import { call, takeLatest, put } from 'redux-saga/effects';
import { post, get } from '../../helpers/server';

// 发送聊天消息 --获取过滤器公式
function* sendTradeChatMessage(action) {
    try {
        const resp = yield call(post, "/order/sendChatMessage", action.payload);
        if (resp && resp.status === 1) {
            yield put({ type: 'send_trade_chat_message_success', reply: resp.r, replyIdeaId: resp.i });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: 'send_trade_chat_message_fail', status: resp.status });
        }
    } catch (e) {
        yield put({ type: 'send_trade_chat_message_fail' });
    }
}

function* Effect() {
    
    yield takeLatest('action_send_trade_chat_message', sendTradeChatMessage);

}

export default Effect;